import { Icon, SVG } from './template';

export const Checkmark = Icon(({ size = 14, width = size, height = size, ...props }, ref) => (
    <SVG {...props} width={width} height={height} ref={ref}>
        <path d="M11.8125 3.9375L5.6875 10.0625L2.625 7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </SVG>
));
